import { IUser } from '../graphql'

export interface TwoFactorSetupResponse {
  otpauthUri: string
  backupCodes: string[]
}

export interface TwoFactorStatusResponse {
  enabled: boolean
  enabledAt: string | null
}

export interface AuthSignInResponse {
  accessToken: string | null
  user: IUser | null
  twoFactorRequired: boolean
  twoFactorToken: string | null
  twoFactorSetupRequired: boolean | null
  twoFactorSetupToken: string | null
}

export enum AuthErrorCode {
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  SESSION_REVOKED = 'SESSION_REVOKED',
  SESSION_TOKEN_REUSE = 'SESSION_TOKEN_REUSE',
  TWO_FACTOR_REQUIRED = 'TWO_FACTOR_REQUIRED',
  BAD_USER_INPUT = 'BAD_USER_INPUT',
  RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED'
}

export enum TwoFactorErrorCodes {
  TWO_FACTOR_REQUIRED = 'TWO_FACTOR_REQUIRED',
  TWO_FACTOR_INVALID_CODE = 'TWO_FACTOR_INVALID_CODE',
  TWO_FACTOR_CHALLENGE_EXPIRED = 'TWO_FACTOR_CHALLENGE_EXPIRED',
  TWO_FACTOR_ALREADY_ENABLED = 'TWO_FACTOR_ALREADY_ENABLED',
  TWO_FACTOR_NOT_ENABLED = 'TWO_FACTOR_NOT_ENABLED'
}
